var _rect, _line, _line2, _line3, _path, _defs, _rect2, _text, _line4, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 9,
    height: 12,
    rx: 1.5,
    fill: "#4A90D9",
    opacity: 0.2,
    stroke: "#4A90D9",
    strokeWidth: 1.4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 7,
    x2: 8.5,
    y2: 7,
    stroke: "#4A90D9",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 9.5,
    x2: 8.5,
    y2: 9.5,
    stroke: "#4A90D9",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 12,
    x2: 7,
    y2: 12,
    stroke: "#4A90D9",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9 L14.5 9",
    stroke: "#666",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    markerEnd: "url(#arr)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arr",
    markerWidth: 5,
    markerHeight: 5,
    refX: 3,
    refY: 2.5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 5,2.5 0,5",
    fill: "#666"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 5.5,
    width: 7.5,
    height: 7,
    rx: 1.5,
    fill: "#7B61FF",
    opacity: 0.2,
    stroke: "#7B61FF",
    strokeWidth: 1.4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 18.25,
    y: 10.5,
    fontSize: 4.5,
    fontFamily: "monospace",
    fill: "#7B61FF",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "LLM")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 18.25,
    y1: 12.5,
    x2: 18.25,
    y2: 16,
    stroke: "#7B61FF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "16.75,16 19.75,16 18.25,18.5",
    fill: "#7B61FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRag);
export default __webpack_public_path__ + "static/media/rag.9c4f0e9f226e8aceb216faec46f38e31.svg";
export { ForwardRef as ReactComponent };